export default 'https://tme.understood.org/assets/Light_Texture00.f7908eda.jpg'